export const CONTACT = {
  phone: "+919876543210",
  email: "info@noova.com",
};
export const SOCIALS = {
  instagram: "https://www.instagram.com/noovascaffolding"
}

